import BaseAnnotationLayer from "./BaseAnnotationLayer";
import {ihcApp} from "../app_maker";
import {store} from "../../../helper/store";
import {openTopApp, updateActiveMap} from "../../../redux_actions/gamma.state.action";
import {expandAnnotation} from "../../../redux_actions/triggers.action";
import Rectangle from "../drawTools/Rectangle";

class IHCLayer extends BaseAnnotationLayer {
	id = ihcApp.id;
	label = "IHC Layer";
	drawer = ihcApp.drawer;
	tools = [Rectangle];


	onFeatureSelect = (feature) => {
		store.dispatch(updateActiveMap(this.props.map.get('id')));
		store.dispatch(openTopApp(ihcApp));
		store.dispatch(expandAnnotation(feature.getId()));
	}
}

export default IHCLayer;
